import React, { useState, useEffect } from "react"

interface HomeProps {
  navigate: (to: "home" | "write" | "feed") => void
}

const Home: React.FC<HomeProps> = ({ navigate }) => {
  const [hover, setHover] = useState(false)

  // load google font
  useEffect(() => {
    const link = document.createElement("link")
    link.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap"
    link.rel = "stylesheet"
    document.head.appendChild(link)
  }, [])

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "radial-gradient(circle at center, #0f172a 0%, #020617 100%)",
        color: "white",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      {/* subtle glow */}
      <div
        style={{
          position: "absolute",
          width: 600,
          height: 600,
          background: "rgba(255,255,255,0.03)",
          borderRadius: "50%",
          filter: "blur(120px)",
        }}
      />

      {/* top logo */}
      <div
        style={{
          position: "absolute",
          top: 40,
          fontSize: 22,
          letterSpacing: 3,
          opacity: 0.8,
        }}
      >
        CONFES
      </div>

      {/* center */}
      <div
        style={{
          textAlign: "center",
          zIndex: 2,
          maxWidth: 720,
          padding: 20,
        }}
      >
        <h1
          style={{
            fontFamily: "Playfair Display, serif",
            fontSize: 64,
            lineHeight: 1.2,
            marginBottom: 20,
          }}
        >
          Say what you can't say anywhere else.
        </h1>

        <p
          style={{
            fontSize: 18,
            opacity: 0.7,
            marginBottom: 40,
          }}
        >
          Anonymous. Safe. No judgement.
        </p>

        <button
          onClick={() => navigate("write")}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            padding: "16px 48px",
            borderRadius: 999,
            border: "1px solid rgba(255,255,255,0.2)",
            background: hover ? "white" : "transparent",
            color: hover ? "#000" : "#fff",
            fontSize: 16,
            cursor: "pointer",
            transition: "all 0.25s ease",
          }}
        >
          Write a confession
        </button>
      </div>

      {/* footer */}
      <div
        style={{
          position: "absolute",
          bottom: 30,
          fontSize: 13,
          opacity: 0.5,
        }}
      >
        Your voice stays anonymous
      </div>
    </div>
  )
}

export default Home